var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('feather-icon',{staticClass:"mr-4",attrs:{"icon":_vm.feature.icon,"svgClasses":_vm.svgClasses}}),_c('div',[_c('span',{staticClass:"font-bold text-xl"},[_vm._v(_vm._s(_vm.feature.name))]),_c('div',[_vm._v(_vm._s(_vm.feature.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }